module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages content"
  }, [_c('section', {
    staticClass: "pages-md-cont"
  }, [_c('z-input', {
    staticClass: "m-t-10",
    attrs: {
      "type": "password",
      "title": "新密码",
      "maxlength": 20,
      "isMust": "true"
    },
    model: {
      value: (_vm.params.password),
      callback: function($$v) {
        _vm.$set(_vm.params, "password", $$v)
      },
      expression: "params.password"
    }
  }), _vm._v(" "), _c('z-input', {
    staticClass: "m-t-10",
    attrs: {
      "type": "password",
      "title": "确认密码",
      "maxlength": 20,
      "isMust": "true"
    },
    model: {
      value: (_vm.params.password1),
      callback: function($$v) {
        _vm.$set(_vm.params, "password1", $$v)
      },
      expression: "params.password1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "m-t-20 fx"
  }, [_c('p', {
    staticClass: "w120 m-r-5 fx-shrink"
  }), _vm._v(" "), _c('a', {
    staticClass: "z-btn z-btn-primary b-r-3",
    on: {
      "click": _vm.handleModifyPwd
    }
  }, [_vm._v("保存")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-51b8887a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/mp/users/ModifyPwd.vue
// module id = 846
// module chunks = 0